import { withForm } from "components/Forms/AppForm";

import { ecrFormDefaultValues } from "./ecrFormDefaultValues";

const EcrCommentTextSection = withForm({
  defaultValues: ecrFormDefaultValues,
  render: function Render({ form }) {
    return (
      <form.FormSection title="Comment Details" columns={1}>
        {/* Comment */}
        <form.AppField name="comment">
          {(field) => <field.HtmlEditor label="Comment" required />}
        </form.AppField>
        {/* Rationale */}
        <form.AppField name="rationale">
          {(field) => <field.HtmlEditor label="Rationale" />}
        </form.AppField>
      </form.FormSection>
    );
  },
});

export default EcrCommentTextSection;
